import { render } from "./Affiliate.vue?vue&type=template&id=b5271c5c&scoped=true"
import script from "./Affiliate.vue?vue&type=script&lang=js"
export * from "./Affiliate.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=b5271c5c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5271c5c"]])

export default __exports__